import environment from '@environment/'
import api from '@api/api'

const endpoints = environment.managerApi.endpoints

const getCurrentAcceptanceTermsEffect = async () => await api.get(endpoints.company.acceptanceTerm)
const getCategoryEffect = () => {
  const result = api.get(endpoints.category.get)
  return result
}
const getVerifyCompanyEffect = async ({ partnerId, companyId }) =>
  await api.get(endpoints.company.verifyExists).replace(':companyId', companyId).replace(':partnerId', partnerId)

export { getCategoryEffect, getCurrentAcceptanceTermsEffect, getVerifyCompanyEffect }
